<template>
  <div class="cards">
    <p>Select and set up preferred payment methods for your shipments</p>
    <div class="methods">
      <div class="method">
        <div class="">
          <h3 class="font-semibold">Wallet</h3>
          <p>
            Set up a MuleEx wallet account and fund it. Your wallet ballance is
            secured and always available to you. Your wallet will be charged
            each time you make a shipment request.
          </p>
        </div>
        <el-switch v-model="wallet" />
      </div>
      <div class="method">
        <div class="">
          <h3 class="font-semibold">Card</h3>
          <p>
            You can add a debit card to you account. Your card will be charged
            each time you make a shipment request. This service is offered
            through Paystack and its secured.
          </p>
        </div>
        <el-switch v-model="payondemand" />
      </div>
      <div class="method">
        <div class="">
          <h3 class="font-semibold">Pay-on-Demand</h3>
          <p>
            You can opt to pay by manually entering your card details each time
            you make shipment request. Your shipment can only be confirmed on
            payment.
          </p>
        </div>
        <el-switch @change="shipping = false"   v-model="shipping" />
      </div>
      <div class="method">
        <div class="">
          <h3 class="font-semibold">Shipping Plan</h3>
          <p>
            You can opt to pay by manually entering your card details each time
            you make shipment request. Your shipment can only be confirmed on
            payment.
          </p>
        </div>
        <el-switch @change="shipment = false" v-model="shipment" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      wallet: false,
      shipping: false,
      shipment: false,
      payondemand: false,
    };
  },
};
</script>
<style lang="scss">
.cards {
  background: #ffffff;
  box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}
.method {
  display: flex;
  border-bottom: 0.5px solid #B7BDCD;
  padding: 1rem 1rem 0.7rem;
  h3{
    padding-bottom: 0.5rem;
  }
}

</style>